import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import {
  courseCrudStateConfig,
  courseDetailsCrudStateConfig,
  courseSectionsCrudStateConfig,
  sectionCrudStateConfig
} from "../../../../const";

const courseDetailsMetaInitialState = makeCrudBuilderInitialState(
  courseDetailsCrudStateConfig
);

const fullCourseMetaInitialState = makeCrudBuilderInitialState(
  courseCrudStateConfig
);

const courseSectionsMetaInitialState = makeCrudBuilderInitialState(
  courseSectionsCrudStateConfig
);

const sectionMetaInitialState = makeCrudBuilderInitialState(
  sectionCrudStateConfig
);

export type CoursesMetaType = {
  courseDetails: CrudBuilderState | Map<any, any>;
  fullCourses: CrudBuilderState | Map<any, any>;
  courseSections: CrudBuilderState | Map<any, any>;
  section: CrudBuilderState | Map<any, any>;
};

const defaultCoursesMeta: CoursesMetaType = {
  courseDetails: courseDetailsMetaInitialState,
  fullCourses: fullCourseMetaInitialState,
  courseSections: courseSectionsMetaInitialState,
  section: sectionMetaInitialState
};

export default class CoursesMeta extends Record(defaultCoursesMeta) {}
